// Напоминание администратору открыть кассовую смену (план 81, Ф4).
//
// Зачем. С планом 81 продать нельзя без открытой смены — вообще ничего, даже
// безналом. Без подсказки это выглядит как поломка: человек жмёт «Продать», а
// кнопка не нажимается. Плашка объясняет причину заранее и ведёт в кассу.
//
// Почему не блокируем интерфейс целиком (решение владельца 10.08): админ
// заходит и просто посмотреть — расписание, контакты, переписку. Смена нужна
// ровно для денег, ей и ограничиваемся.
//
// Кому: роль `admin`. Управляющий и старший администратор кассу ведут не
// каждый день, продажникам и педагогам она не нужна вовсе.
import { Link } from 'react-router-dom';

import { useOpenShift } from '@/features/clients/hooks/useSellSubscription';
import { useAuth } from '@/lib/auth-context';
import { useDefaultFormBranchId } from '@/lib/tenant-context';

export function OpenShiftReminder(): JSX.Element | null {
  const { user } = useAuth();
  // План 106: при ОДНОМ выбранном филиале спрашиваем про него; при нескольких
  // или «Все филиалы» — как раньше «есть ли вообще открытая смена». Проверять
  // каждый выбранный нельзя: это хук-на-филиал в цикле (React #310), да и
  // плашка о чужой точке только шумит.
  const branchId = useDefaultFormBranchId();
  const isAdmin = user?.role === 'admin';

  // Хук зовём ВСЕГДА (правило хуков), но запрос уходит только у админа:
  // `GET /cash/shifts` закрыт правом `reports:branch_finance`, которого нет у
  // педагога, — иначе он ловил бы 403 на каждой странице.
  const shift = useOpenShift({ branchId, enabled: isAdmin });

  if (!isAdmin) return null;
  // Пока грузится и при ошибке молчим: плашка-ошибка пугает сильнее, чем
  // помогает, а настоящая причина всплывёт при попытке продать.
  if (shift.isLoading || shift.isError) return null;
  if (shift.data) return null;

  return (
    <div className="mb-4 flex flex-wrap items-center justify-between gap-3 rounded-card border border-soft-orange/40 bg-soft-orange/10 px-4 py-3">
      <span className="text-sm text-ink-black">
        Кассовая смена не открыта — продать абонемент или принять оплату нельзя.
      </span>
      <Link
        to="/cash"
        className="shrink-0 rounded-full bg-primary px-4 py-1.5 text-sm font-medium text-primary-foreground hover:opacity-90"
      >
        Открыть смену
      </Link>
    </div>
  );
}
